import { put } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as singInActions } from '../signInUseCase/actions';
import { Types as validateActions } from '../validateUserUseCase/actions';
import { KeycloakManager } from '../../../../core/managers/keycloakManager';

export default function* execute(): any {
  yield put({ type: singInActions.SIGN_OUT_REQUEST });
  const { refreshToken } = KeycloakManager.getInstance().getToken();
  if (!refreshToken) return;
  localStorage.clear();
  yield KeycloakManager.getInstance().logout();
  yield put({ type: Types.SIGN_OUT_SUCCESS });
  yield put({ type: validateActions.SIGN_OUT });
  yield put({ type: singInActions.SIGN_OUT_SUCCESS });
}
